import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParticleBackground from "@/components/ParticleBackground";
import AIGrid from "@/components/AIGrid";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      <ParticleBackground />
      <AIGrid />
      <Navigation />

      <main className="flex-grow pt-32 pb-20 relative z-10">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4">Privacy Policy</h1>
            <p className="text-muted-foreground text-lg">Final content to be provided by Holionix. Placeholder structure below.</p>
          </motion.div>

          <Card className="p-8 glass-effect border-primary/30 max-w-4xl mx-auto">
            <div className="space-y-6 text-sm leading-relaxed text-muted-foreground">
              <ol className="list-decimal pl-6 space-y-4">
                <li>
                  <p className="font-semibold text-foreground mb-1">Scope</p>
                  <p>
                    These terms and conditions apply to all contracts concluded via the website between the provider (hereinafter "we") and the customer, unless expressly agreed otherwise.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Vehicle sale</p>
                  <p>
                    All offers presented on the website are subject to change and non-binding. A contract for the purchase of a vehicle only comes into effect upon written confirmation or the conclusion of a written purchase agreement.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Vehicle purchase</p>
                  <p>
                    When a customer offers a vehicle via the form, this does not yet constitute a binding offer. We will contact you after reviewing the offer. A binding purchase will only take place after a personal inspection and a written agreement.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Prizes</p>
                  <p>
                    All prices are quoted in euros and include VAT unless otherwise stated.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Warranty</p>
                  <p>
                    Sales to consumers are subject to statutory warranty rights. Sales to businesses are made excluding any warranty, unless otherwise agreed.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Liability</p>
                  <p>
                    We are only liable for damages resulting from an intentional or grossly negligent breach of duty. In cases of slight negligence, we are only liable if a material contractual obligation (a so-called cardinal obligation) has been breached. In this case, liability is limited to foreseeable damages.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Data protection</p>
                  <p>
                    Our privacy policy applies. Personal data will be used exclusively for processing your request and for fulfilling contracts.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Place of jurisdiction</p>
                  <p>
                    If the customer is an entrepreneur or does not have a residence in the European Union, the place of jurisdiction is our company headquarters.
                  </p>
                </li>
                <li>
                  <p className="font-semibold text-foreground mb-1">Final Provisions</p>
                  <p>
                    Should individual provisions of these terms and conditions be wholly or partially invalid, the validity of the remaining provisions shall remain unaffected.
                  </p>
                </li>
              </ol>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;


